import { SearchQuestion } from './SearchQuestion';
export default SearchQuestion;
